import { useCallback, useRef } from 'react';
const useDebouncedCallback = (callback, delay) => {
  const timeoutRef = useRef();

  return useCallback(
    (...args) => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      timeoutRef.current = setTimeout(() => {
        callback?.(...args);
      }, delay);
    },
    [callback, delay]
  );
};

export { useDebouncedCallback as default, useDebouncedCallback };
